import React from 'react';
import { useAuth } from '../../lib/auth';
import { useNavigation } from '../../lib/navigation';
import { resolveAssetUrl } from '../../lib/ultra-meet-config';
import { LanguageSwitcher } from '../shared/LanguageSwitcher';
import { ThemeSelector } from '../shared/ThemeSelector';
import { UserAvatar } from '../shared/UserAvatar';
import styles from '../../styles/AuthenticatedHome.module.css';
import { ROUTES } from '../../lib/routes';

interface TopBarProps {
  translations: any;
}

export const TopBar: React.FC<TopBarProps> = ({ translations }) => {
  const t = translations.home;
  const navigation = useNavigation();
  const { user, signOut } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut();
      navigation.push(ROUTES.HOME);
    } catch (error) {
      console.error('Failed to logout:', error);
    }
  };

  return (
    <div className={styles.topBar}>
      <div className={styles.languageSwitcherContainer}>
        <LanguageSwitcher />
        <ThemeSelector />
      </div>
      <div className={styles.userSection}>
        {user && <UserAvatar photoUrl={user.photoUrl} name={user.displayName} email={user.email} className={styles.userAvatar} />}
        <span className={styles.userName}>{user?.displayName || ''}</span>
        <button className={styles.logoutButton} onClick={handleLogout}>
          <img src={resolveAssetUrl('/images/ic_logout.svg')} alt="logout" width="20" height="20" />
          {t.logout}
        </button>
      </div>
    </div>
  );
};
